import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cscPaymentMethods = {
  gap: css`var(--csc-payment-methods-gap, ${csSpacing.spacing04})`,
}

export const paymentMethodList = css`
  :host {
    --cse-selectable-padding-x: ${csSpacing.spacing05};
    --cse-selectable-padding-y: ${csSpacing.spacing05};
  }

  .payment-method-list {
    display: flex;
    flex-direction: column;
    gap: ${cscPaymentMethods.gap};
    padding: ${csSpacing.spacing06} 0;
  }
`

export const paymentMethodSelectable = css`
  .selectable-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${csSpacing.spacing05};
  }
`
